/**
 * Outlet context — persists the current outlet selection in localStorage so
 * every procurement tab, count, queue and export respects the same filter.
 *
 * Codes: "ALL" | "TBB" | "TMC" | "MC"
 * "ALL" means no filter — vendors, items, transactions from every outlet.
 */
import { createContext, useContext, useEffect, useState } from "react";

const STORAGE_KEY = "tbb_procurement_outlet";
const OutletContext = createContext(null);

export const OUTLETS = [
  { code: "ALL", name: "All Outlets" },
  { code: "TBB", name: "The Barracks Bistro" },
  { code: "TMC", name: "The Madras Café" },
  { code: "MC",  name: "Museum Café" },
];

export function OutletProvider({ children }) {
  const [outlet, setOutletState] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) || "ALL"; }
    catch { return "ALL"; }
  });
  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, outlet); } catch {}
  }, [outlet]);
  const setOutlet = (code) => setOutletState(code);
  // outletParam is what to send to backend — undefined when ALL so no filter is applied.
  const outletParam = outlet === "ALL" ? undefined : outlet;
  return (
    <OutletContext.Provider value={{ outlet, setOutlet, outletParam, outlets: OUTLETS }}>
      {children}
    </OutletContext.Provider>
  );
}

export function useOutlet() {
  const ctx = useContext(OutletContext);
  if (!ctx) throw new Error("useOutlet must be used inside <OutletProvider>");
  return ctx;
}
